import { useTranslation } from 'react-i18next';
import { useSyncing } from '../lib/useConnectionStatus';

/**
 * Индикатор «Соединение…» / «Обновление…» с бегущими точками — показывается, пока WS-соединение
 * разорвано или идёт догоняющая сверка (см. useConnectionStatus). Используется и в шапке чата
 * (ChatView), и в сайдбаре списка чатов (ChatList); className задаёт позиционирование.
 */
export default function ConnectingBadge({ className }: { className?: string }) {
  const { t } = useTranslation('misc');
  const syncing = useSyncing();
  return (
    <div className={className}>
      {syncing ? t('connectingUpdating') : t('connectingConnecting')}<span className="connecting-dots"><span>.</span><span>.</span><span>.</span></span>
    </div>
  );
}
